import { gql } from '@apollo/client';

const GET_STUDENT_ASSESSMENT = gql`
  query getStudentAssessment($where: StudentAssessmentWhereInput!) {
    studentAssessment(where: $where) {
      id
      assessmentId
      studentId
      dateAdministered
      student {
        id
      }
      assessment {
        id
        ...AssessmentImplementations
        ...AssessmentDomainsAndSections
      }
      dateCompleted
      comments
    }
  }
`;

export default GET_STUDENT_ASSESSMENT;
